/**
 * Helper to extract filename from Content-Disposition header
 */
const extractFilename = (contentDisposition, defaultName) => {
  if (!contentDisposition) return defaultName;
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  const matches = filenameRegex.exec(contentDisposition);
  if (matches != null && matches[1]) {
    return matches[1].replace(/['"]/g, "");
  }
  return defaultName;
};

/**
 * Download a Blob as a file in the browser
 */
export const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  
  // Clean up
  link.parentNode.removeChild(link);
  window.URL.revokeObjectURL(url);
};

/**
 * Handle API response for file download
 */
export const handleFileDownload = (response, defaultFilename = "export.pdf") => {
  if (response.data instanceof Blob) {
    const filename = extractFilename(
      response.headers["content-disposition"],
      defaultFilename
    );
    downloadBlob(response.data, filename);
    return true;
  }
  return false;
};
